// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AppStoreLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m8.043 25.514-1.182 2a1 1 0 1 1-1.722-1.017l1.182-2a1 1 0 1 1 1.722 1.017ZM29 20.005h-5.975l-3.841-6.5a1 1 0 1 0-1.722 1.018l7.677 12.991a1 1 0 1 0 1.722-1.017l-2.654-4.492H29a1 1 0 0 0 0-2Zm-11.191 0h-6.512l8.564-14.491a1 1 0 1 0-1.722-1.017L16 8.117l-2.139-3.625a1 1 0 1 0-1.722 1.017l2.7 4.569-5.864 9.927H3a1 1 0 1 0 0 2h14.809a1 1 0 0 0 0-2Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
